import * as React from 'react'
import { ShipmentShape } from '../../api/api_data_types'
import RemoveFieldsButton from '../shared/RemoveFieldsButton'

type ManualShipmentFieldsProps = {
  shipment: ShipmentShape
  onChange: (data: ShipmentShape) => void
  onRemove: () => void
  index: number
  fieldNameFn: (field: string) => string
}

export default function ManualShipmentFields(props: ManualShipmentFieldsProps) {
  const { shipment, onChange, onRemove, index, fieldNameFn } = props
  const canRemove = !shipment.id

  return (
    <div className="manual-shipment-row mb-3 p-3 border rounded position-relative">
      {canRemove && <RemoveFieldsButton className="resources-remove-fields-button" handleRemove={onRemove} />}
      <input type="hidden" name={fieldNameFn('type')} value="Shipments::Manual" />
      <input type="hidden" name={fieldNameFn('id')} value={shipment.id || ''} />
      <input type="hidden" name={fieldNameFn('approved')} value={shipment.approved ? '1' : '0'} />
      <input type="hidden" name={fieldNameFn('jobnumber_id')} value={shipment.jobnumber_id} />

      <div className="row">
        <div className="col-4">
          <label>Leverandør</label>
          <input
            type="text"
            className="form-control"
            value={shipment.provider || ''}
            onChange={e => onChange({ ...shipment, provider: e.target.value })}
            name={fieldNameFn('provider')}
            required
          />
        </div>
        <div className="col-4">
          <label>By</label>
          <input
            type="text"
            className="form-control"
            value={shipment.city || ''}
            onChange={e => onChange({ ...shipment, city: e.target.value })}
            name={fieldNameFn('city')}
            required
          />
        </div>
        <div className="col-4">
          <label>Firma</label>
          <input
            type="text"
            className="form-control"
            value={shipment.company || ''}
            onChange={e => onChange({ ...shipment, company: e.target.value })}
            name={fieldNameFn('company')}
            required
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-7">
          <label>Sporingsnummer</label>
          <input
            type="text"
            className="form-control"
            value={shipment.tracking_number || ''}
            onChange={e => onChange({ ...shipment, tracking_number: e.target.value })}
            name={fieldNameFn('tracking_number')}
          />
        </div>
        <div className="col-2">
          <label>Vægt (kg)</label>
          <input
            type="number"
            className="form-control"
            value={shipment.weight || ''}
            onChange={e => onChange({ ...shipment, weight: e.target.value })}
            name={fieldNameFn('weight')}
            step="0.01"
            min="0"
            required
          />
        </div>
        <div className="col-3">
          <label>Pris</label>
          <input
            type="number"
            className="form-control"
            value={shipment.price || ''}
            onChange={e => onChange({ ...shipment, price: e.target.value })}
            name={fieldNameFn('price')}
            step="0.01"
            min="0"
            required
          />
        </div>
      </div>
    </div>
  )
}
